import ContentShell from '../components/blog/ContentShell'
import Seo from '../components/blog/Seo'
import Button from '../components/ui/Button'

/** Real 404 page. Prerendered to dist/404.html (Cloudflare Pages); marked noindex. */
export default function NotFound() {
  return (
    <ContentShell>
      <Seo
        title="Page not found | BankStatementReader"
        description="The page you were looking for could not be found."
        canonicalPath="/404"
        noindex
      />
      <div className="mx-auto max-w-2xl py-20 text-center">
        <p className="text-6xl font-bold text-ink m-0">404</p>
        <h1 className="text-2xl font-bold text-ink mt-4">Page not found</h1>
        <p className="text-ink-soft mt-3 mb-8">The page you were looking for doesn’t exist or has moved.</p>
        <div className="flex justify-center gap-4">
          <Button to="/">Go home</Button>
          <Button to="/blog" variant="secondary">
            Browse the blog
          </Button>
        </div>
      </div>
    </ContentShell>
  )
}
